import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { AssignableUserProfile } from '../../../domains/userManagement/types';

const ENDPOINT = `${APIConfiguration.authorization}users/listUserProfile`;

export interface ListUserProfileQueryPayload {
  tenantId: string;
}

export const listUserProfileRequest = ({
  tenantId,
}: ListUserProfileQueryPayload): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT, { tenantId }, { skipNulls: true }),
  config: { method: SUPPORTED_METHODS.GET },
});

export const listUserProfileQuery = async (
  payload: ListUserProfileQueryPayload,
): Promise<BackResponse<AssignableUserProfile[]> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<AssignableUserProfile[]>>(
      listUserProfileRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
